import api from "./../utils/api";

export const searchProduct = async (query) => {
    try {
        const response = await api.get(
            `/search/product?q=${query}`,
            {
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};